import { render } from "./UsersThreeIcon.vue?vue&type=template&id=1aa6e7b2"
const script = {}

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__